import { CropConfiguration } from "./cropConfiguration";
import { Feature, MultiPolygon } from "geojson";
import {
    ApplicationTechnique,
    ApplicationMethod,
    ProcessingStatus,
} from "./enums";
export interface HarvestOperation {
    id: number;
    field: number;
    start_date: string;
    end_date: null;
    created_by: null;
    last_modified_by: null;
    provider: null;
    source_id: null;
    file_name: string;
    irrigated_averages?: {
        yield: number;
        moisture: number;
        corrected_yield: number;
    };
    field_averages: {
        yield: number;
        moisture: number;
        corrected_yield: number;
    };
    note: null;
    bounds: number[];
    file_processing_status: ProcessingStatus | null;
}

export interface ListApplications {
    summary: {
        image: null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        rates: any[];
    };
    operations: ApplicationOperation[];
}

export interface ApplicationOperation {
    id: number;
    field: number;
    start_date: string;
    end_date: string;
    created_by: null;
    last_modified_by: null;
    provider: string;
    source_id: string;
    file_name: null;
    average_N: number;
    note: null;
    fertilizer_system: null;
    application_products: {
        id: number;
        price: null;
        product: {
            id: number;
            name: string;
            fertilizer_type: number;
        };
        alias: null;
    }[];
    prescription: number;
    is_complete: boolean;
    technique: ApplicationTechnique;
    method: ApplicationMethod;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    irrigation_operation: any;
    bounds: number[];
    file_processing_status: ProcessingStatus | null;
}

export interface PlantingOperation {
    id: number;
    field: number;
    start_date: string;
    end_date: string;
    created_by: null;
    last_modified_by: null;
    provider: null;
    source_id: null;
    file_name: null;
    average_seeding_rate: number;
    average_planting_depth: null;
    note: null;
    varieties: Variety[];
    crop_configuration: CropConfiguration;
    bounds: number[];
    file_processing_status: ProcessingStatus | null;
}

export interface Variety {
    id: number;
    grower: number;
    name: string;
    gdd_mature: number;
    gdd_silk: null;
    maturity_level: null;
    rice_type: null;
    sugarcane_type: null;
    soybean_maturity_group: null;
    created_by: null;
    last_modified_by: null;
    crm: number | null;
}

export interface SectorSummary {
    irrigation_system: number;
    sectors: Feature<
        MultiPolygon,
        {
            start: number;
            stop: number;
            mean: number;
            treatment: string;
        }
    >[];
    band: number;
}
export const TECHNIQUE_TYPES = [
    { name: "Broadcast (Surface)", value: "Broadcast (Surface)" },
    { name: "Broadcast (Incorporated)", value: "Broadcast (Incorporated)" },
    { name: "Banded (Surface)", value: "Banded (Surface)" },
    { name: "Banded (Below Surface)", value: "Banded (Below Surface)" },
    { name: "Foliar Applied", value: "Foliar Applied" },
    { name: "On Seed", value: "On Seed" },
    { name: "Injected", value: "Injected" },
    { name: "Fertigation", value: "Fertigation" },
];

export const OPTIMAL_APPROACH_TYPES = [
    { name: "N Uptake 4%", value: "N_UPTAKE_4_PERC_THRESHOLD" },
    { name: "N Uptake 3%", value: "N_UPTAKE_3_PERC_THRESHOLD" },
    { name: "N Uptake 2%", value: "N_UPTAKE_2_PERC_THRESHOLD" },
    { name: "Optimal Profit", value: "OPTIMAL_PROFIT" },
    { name: "Imagery Only", value: "IMAGERY_ONLY" },
];

export const DEFAULT_SEEDING_RATE = 34000;
export const DEFAULT_PLANTING_DEPTH = 2.0;

export interface ListIrrigations {
    summary: {
        image: null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        rates: any[];
    };
    operations: IrrigationOperation[];
}

export interface IrrigationOperation {
    id: number;
    field: number;
    irrigation_system: number;
    start_date: string;
    end_date: string;
    note: null;
    application_operations: number[];
    average_depth: number | null;
    bounds: number[];
}
